/**
 * Responsive base styles for images rendered inside article content and
 * Markdown previews. Intrinsic dimensions may still be present in the markup,
 * but they cannot make an image wider than its content column or distort its
 * aspect ratio.
 */
export const articleImageStyles = `
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto 1em;
  }
`;
